document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }
  document.querySelectorAll('[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (!button) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: {'Accept':'application/json'}, body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add');
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
        button.textContent = 'Added ✓';
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1200);
      } catch (error) {
        button.textContent = 'Try again';
        button.disabled = false;
      }
    });
  });
  document.querySelectorAll('[data-carousel-section]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track || !previous || !next) return;
    const move = (direction) => {
      const slide = track.querySelector('.cc-carousel-slide');
      const distance = slide ? slide.getBoundingClientRect().width + 18 : track.clientWidth * 0.85;
      track.scrollBy({left: direction * distance, behavior: 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });
});
